/**
 * @generated SignedSource<<5e15018685f0f8fc431c1a054a937962>>
 * @relayHash 1aed146137e3e58f4e905eaa4f891748
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf4ac78d97f3f9a7ba35ca6fa278e16eb0076188cba5c0c55eff9a4dd7ab76a1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cf4ac78d97f3f9a7ba35ca6fa278e16eb0076188cba5c0c55eff9a4dd7ab76a1",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
